<template>
    <App>
      <div class="card">
        <div class="card-body">
          <h1>Dashboard</h1>
        </div>
      </div>
    </App>
</template>
<script>
import App from "@layout/App";

export default {
    mounted() {
        this.emitter.emit('title',  'Dashboard');
    },

    components: {
        App,
    },
};
</script>
